export const mockData = {
  brand: {
    name: 'BIJAYA SOLAR',
    tagline: 'Powering Odisha with Clean Energy',
    location: 'H.O - Plot 611, Bharat Villa, Hanspal, BBSR',
    phone: '+91 9262626026',
    whatsapp: '9262626026',
    email: 'sales@bijaya-enterprises.com'
  },
  
  hero: {
    headline: 'Get ₹1,38,000 Subsidy + Save Lakhs on Electricity Bills',
    subHeadline: 'Join 500+ Odisha Families Already Saving with Rooftop Solar',
    ctaPrimary: 'Get Your Solar Savings & Subsidy Estimate',
    ctaSecondary: 'Check Subsidy Eligibility',
    stats: [
      { value: '500+', label: 'Happy Homes' },
      { value: '₹1,38,000', label: 'Max Subsidy' },
      { value: '25 Years', label: 'Warranty' },
      { value: '7-10 Days', label: 'Installation' }
    ]
  },
  
  problems: [
    {
      title: 'Rising Electricity Bills',
      description: 'Your monthly bill keeps increasing. Imagine paying ₹0 instead.',
      icon: 'TrendingUp'
    },
    {
      title: 'Frequent Power Cuts',
      description: 'Tired of load shedding? Generate your own power 24/7.',
      icon: 'Zap'
    },
    {
      title: 'DISCOM Dependency',
      description: 'Stop relying on unpredictable grid power. Be energy independent.',
      icon: 'AlertCircle'
    }
  ],
  
  solution: {
    title: 'How Rooftop Solar Works',
    description: 'Simple, clean energy that pays for itself',
    steps: [
      {
        step: '1',
        title: 'Solar Panels Capture Sunlight',
        description: 'Premium panels convert sunlight into electricity during the day'
      },
      {
        step: '2',
        title: 'Powers Your Home',
        description: 'Run all appliances - AC, fridge, TV, lights - for free'
      },
      {
        step: '3',
        title: 'Excess Goes to Grid',
        description: 'Net metering credits extra power. Your meter runs backward!'
      },
      {
        step: '4',
        title: 'Your Bill Drops to ₹0',
        description: 'Save ₹5,000-₹15,000 every month. Forever.'
      }
    ]
  },
  
  subsidy: {
    title: 'PM Surya Ghar Yojana Subsidy',
    description: 'Central Govt & State Govt is giving you FREE money. Don\'t miss out!',
    urgency: 'Limited-time subsidy - Apply before slots fill up',
    plans: [
      {
        capacity: '1 kW',
        subsidy: '₹55,000',
        totalCost: '₹60,000',
        afterSubsidy: '₹5,000',
        monthlySaving: '₹600',
        idealFor: '2-3 BHK',
        popular: false
      },
      {
        capacity: '2 kW',
        subsidy: '₹1,10,000',
        totalCost: '₹1,60,000',
        afterSubsidy: '₹40,000',
        monthlySaving: '₹1,500',
        idealFor: '3-4 BHK',
        popular: false
      },
      {
        capacity: '3 kW',
        subsidy: '₹1,38,000',
        totalCost: '₹2,00,000',
        afterSubsidy: '₹62,000',
        monthlySaving: '₹2,500',
        idealFor: '4+ BHK',
        popular: true
      }
    ]
  },
  
  whyUs: [
    {
      title: 'Local Odisha Presence',
      description: 'Based in Odisha, serving Odisha. Quick support, no delays.',
      icon: 'MapPin'
    },
    {
      title: 'MNRE Approved',
      description: 'Government-certified components. Quality guaranteed.',
      icon: 'Award'
    },
    {
      title: '25-Year Warranty',
      description: 'Premium panels with performance guarantee. Worry-free.',
      icon: 'Shield'
    },
    {
      title: '7-10 Days Installation',
      description: 'Fast, professional setup. Start saving immediately.',
      icon: 'Clock'
    },
    {
      title: 'Subsidy Assistance',
      description: 'We handle all paperwork. You just sit back.',
      icon: 'FileText'
    },
    {
      title: 'Net Metering Support',
      description: 'Complete support for DISCOM approvals and connections.',
      icon: 'Activity'
    }
  ],
  
  testimonials: [
    {
      name: 'Rajesh Panda',
      location: 'Bhubaneswar',
      rating: 5,
      text: 'My electricity bill was ₹8,000/month. Now it\'s ₹0! Bijaya Solar handled everything - subsidy, installation, net metering. Highly recommended!',
      system: '3 kW',
      savings: '₹96,000/year'
    },
    {
      name: 'Sujata Mohanty',
      location: 'Cuttack',
      rating: 5,
      text: 'Best decision ever! Installation took just 8 days. Got ₹60,000 subsidy. Very professional team.',
      system: '2 kW',
      savings: '₹60,000/year'
    },
    {
      name: 'Prakash Nayak',
      location: 'Rourkela',
      rating: 5,
      text: 'No more power cuts during summer! Solar runs my AC all day. The subsidy made it super affordable.',
      system: '2 kW',
      savings: '₹55,000/year'
    }
  ],
  
  process: [
    {
      step: '1',
      title: 'Free Site Survey',
      description: 'Our expert visits your home to assess roof space and energy needs',
      duration: 'Same day'
    },
    {
      step: '2',
      title: 'Custom Design',
      description: 'We design the perfect solar system for your home and budget',
      duration: '1-2 days'
    },
    {
      step: '3',
      title: 'Professional Installation',
      description: 'Expert team installs panels with zero damage to your roof',
      duration: '2-3 days'
    },
    {
      step: '4',
      title: 'Net Metering Setup',
      description: 'DISCOM approval and bidirectional meter installation',
      duration: '2-3 days'
    },
    {
      step: '5',
      title: 'Subsidy Application',
      description: 'We handle all government paperwork and approvals',
      duration: '3-5 days'
    },
    {
      step: '6',
      title: 'Start Saving!',
      description: 'Your system goes live. Watch your electricity bill drop to ₹0',
      duration: 'Lifetime'
    }
  ],
  
  faq: [
    {
      question: 'How much subsidy will I get?',
      answer: 'Under PM Surya Ghar Yojana: ₹55,000 for 1kW, ₹1,10,000 for 2kW, ₹1,38,000 for 3kW. We help you claim the maximum amount.'
    },
    {
      question: 'What is the total cost after subsidy?',
      answer: 'A 2kW system costs ₹1,60,000. After ₹1,10,000 subsidy, you pay only ₹40,000. It pays for itself in 2-3 years through savings!'
    },
    {
      question: 'Do solar panels work during power cuts?',
      answer: 'With battery backup (optional), yes! Otherwise, the system works when grid is available. We can add batteries to your system.'
    },
    {
      question: 'How long does installation take?',
      answer: '7-10 days total including subsidy application, DISCOM approval, and installation. We handle everything.'
    },
    {
      question: 'What about maintenance?',
      answer: 'Very low maintenance. Just clean panels twice a year. Our 25-year warranty covers any issues.'
    }
  ]
};

export default mockData;